import { render, staticRenderFns } from "./logo-dark.vue?vue&type=template&id=d01b6fe8&"
var script = {}
import style0 from "./logo-dark.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports